import React from 'react';
import { Button } from '@utex/ui-kit';
import { observer } from 'mobx-react';
import { useConversionService } from '../../../hooks/useConversionService';
import { buttonStyle } from './styles';

interface Props {
  currencyFrom: string;
  onClick?: () => void;
}

export const Direction: React.FC<Props> = observer(({ currencyFrom, onClick, children }) => {
  const { currencyFrom: actualCurrencyFrom, changeCurrencyFrom } = useConversionService();
  return (
    <Button
      onClick={() => {
        changeCurrencyFrom(currencyFrom);
        onClick && onClick();
      }}
      view={currencyFrom === actualCurrencyFrom ? 'regular-shadow' : 'transparent'}
      shape="round"
      css={buttonStyle}
    >
      {children}
    </Button>
  );
});
